import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { UI } from './operationalUi';

export default function FunnelStageLabel({
  step,
  label,
  children,
}: {
  step: number;
  label: string;
  children: React.ReactNode;
}) {
  return (
    <Stack direction="row" spacing={1} alignItems="flex-start">
      <Box
        component="span"
        role="img"
        aria-label={`Step ${step}`}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 20,
          height: 20,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: UI.sand,
          color: UI.teal,
          fontSize: 11,
          fontWeight: 600,
        }}
      >
        {step}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{label}</Typography>
        {children}
      </Box>
    </Stack>
  );
}
